import { CommonModule } from '@angular/common';
import { Component, inject, Injector, input, OnInit } from '@angular/core';
import { DocumentItemPartial, SignedByPartial } from '@domain';
import { TranslateService } from '@ngx-translate/core';
import { SignatureTypePipe } from '../../../../../../shared/pipes/documents/signature-type.pipe';

@Component({
    selector: 'signature-data',
    templateUrl: 'signature-data.component.html',
    styleUrls: ['signature-data.component.scss', '../../document-preview.scss'],
    imports: [CommonModule, SignatureTypePipe],
})
export class SignatureDataComponent implements OnInit {
    public item = input.required<DocumentItemPartial>();
    public signatures: SignedByPartial[] = [];

    private _injector = inject(Injector);

    ngOnInit(): void {
        this._buildSignatures();
    }

    private _buildSignatures(): void {
        const raw = (this.item()?.value as (SignedByPartial | null | undefined)[]) || [];
        const signatures = raw.filter((s): s is SignedByPartial => s != null);

        this.signatures = signatures.map(signature => ({
            name: signature.name || this._injector.get(TranslateService).instant('document.preview.signatureData.fallbackName'),
            fontFamily: this._resolveFontFamily(signature.fontFamily),
            signedAt: signature.signedAt,
            type: signature.type,
            email: signature.email,
        }));
    }

    private _resolveFontFamily(fontFamily?: string): string {
        if (!fontFamily?.trim()) {
            return "'Sacramento', cursive";
        }

        if (fontFamily.includes(',') || fontFamily.includes("'") || fontFamily.includes('"')) {
            return fontFamily;
        }

        return `'${fontFamily}', cursive`;
    }
}
